import { render, staticRenderFns } from "./EmailPhoneUpdateVerification.vue?vue&type=template&id=322c6408&scoped=true"
import script from "./EmailPhoneUpdateVerification.vue?vue&type=script&lang=js"
export * from "./EmailPhoneUpdateVerification.vue?vue&type=script&lang=js"
import style0 from "./EmailPhoneUpdateVerification.vue?vue&type=style&index=0&id=322c6408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c6408",
  null
  
)

export default component.exports